import { handleActions } from 'redux-actions'
import { createNamespace } from 'redux-actions-namespace'

import {
  getCurrenciesDebounced as getCurrencies,
  getTokensDebounced as getTokens
} from './calculations/estimates'
import { getAllDepositsDebounced as getAllDeposits } from './calculations/prices/all_deposits'
import calculatorSelector from 'selectors/calculator'

const defaults = { getCurrencies }

export default (namespace, { getCurrencies } = defaults) => {
  const { createAction } = createNamespace(`${namespace}/`)

  const setCoinAmount = createAction('CALCULATOR_SET_COIN_AMOUNT')
  const incrementCoinAmount = createAction('CALCULATOR_INCREMENT_COIN_AMOUNT')
  const decrementCoinAmount = createAction('CALCULATOR_DECREMENT_COIN_AMOUNT')
  const setCoinPrice = createAction('CALCULATOR_SET_COIN_PRICE')
  const toggleDirection = createAction('CALCULATOR_TOGGLE_DIRECTION')
  const setCode = createAction('CALCULATOR_SET_CODE')
  const toggleAllDeposits = createAction('CALCULATOR_TOGGLE_ALL_DEPOSITS')
  const setTokenPurchaseType = createAction('CALCULATOR_SET_TOKEN_PURCHASE_TYPE')

  const calculateCoinAmount = (coin_amount, force) => (dispatch, getState) => {
    dispatch(setCoinAmount(coin_amount))
    dispatch(getCurrencies(coin_amount, force))
  }
  const calculateIncrementCoinAmount = () => (dispatch, getState) => {
    dispatch(incrementCoinAmount())
    const calculator = calculatorSelector(namespace)(getState())
    const { coin_amount } = calculator
    dispatch(getCurrencies(coin_amount))
  }
  const calculateDecrementCoinAmount = () => (dispatch, getState) => {
    dispatch(decrementCoinAmount())
    const calculator = calculatorSelector(namespace)(getState())
    const { coin_amount } = calculator
    dispatch(getCurrencies(coin_amount))
  }
  const calculateToggleAllDeposits = () => (dispatch, getState) => {
    const calculator = getState().calculator[namespace]
    if (calculator.all_deposits) {
      const { coin_amount } = calculator
      dispatch(calculateCoinAmount(coin_amount))
    } else {
      dispatch(getAllDeposits()).then(({ json: { coin_amount } }) =>
        dispatch(setCoinAmount(coin_amount))
      )
    }
    dispatch(toggleAllDeposits())
  }
  const calculateCoinPrice = (coin_price, force) => (dispatch, getState) => {
    dispatch(setCoinPrice(coin_price))
    dispatch(getTokens(coin_price, force))
  }
  const calculateToggleDirection = () => (dispatch, getState) => {
    const calculator = calculatorSelector(namespace)(getState())
    const { coin_amount, coin_price } = calculator
    dispatch(
      calculator.direction !== 'right' ? setCoinAmount(coin_amount) : setCoinPrice(coin_price)
    )
    dispatch(toggleDirection())
  }

  const calculateTokenPurchaseType = type_id => dispatch => {
    dispatch(setTokenPurchaseType(type_id))
    dispatch(recalculate())
  }

  const recalculate = () => (dispatch, getState) => {
    const calculator = calculatorSelector(namespace)(getState())
    const { all_deposits, direction, coin_amount, coin_price } = calculator
    all_deposits
      ? dispatch(getAllDeposits()).then(({ json: { coin_amount } }) =>
          dispatch(setCoinAmount(coin_amount))
        )
      : dispatch(
          direction === 'right'
            ? calculateCoinAmount(coin_amount, true)
            : calculateCoinPrice(coin_price, true)
        )
  }

  const initialState = {
    coin_amount: 0,
    coin_price: 0,
    direction: 'right',
    code: '',
    all_deposits: false,
    token_purchase_type_id: 1
  }

  const reducer = handleActions(
    {
      [setCoinAmount]: (state, { payload }) => ({ ...state, coin_amount: payload }),
      [incrementCoinAmount]: state => ({
        ...state,
        coin_amount: +state.coin_amount + 1
      }),
      [decrementCoinAmount]: state => ({
        ...state,
        coin_amount: state.coin_amount - 1 < 0 ? 0 : state.coin_amount - 1
      }),
      [setCoinPrice]: (state, { payload }) => ({ ...state, coin_price: payload }),
      [toggleDirection]: state => ({
        ...state,
        direction: state.direction === 'right' ? 'left' : 'right'
      }),
      [setCode]: (state, { payload }) => ({ ...state, code: payload }),
      [toggleAllDeposits]: state => ({
        ...state,
        all_deposits: !state.all_deposits
      }),
      [setTokenPurchaseType]: (state, { payload }) => ({
        ...state,
        token_purchase_type_id: payload
      })
    },
    initialState
  )

  return {
    setCode,
    calculateCoinAmount,
    calculateIncrementCoinAmount,
    calculateDecrementCoinAmount,
    calculateToggleAllDeposits,
    calculateCoinPrice,
    calculateToggleDirection,
    calculateTokenPurchaseType,
    recalculate,
    reducer
  }
}



// WEBPACK FOOTER //
// ./src/modules/calculator.js